import { CommonInput, CommonModal } from 'components';
import React, { useState, useEffect, useContext } from 'react'
import './adjustBal.css'
import { constant } from 'constants/constant';
import StorageService from 'utils/StorageServices';
import { DatePickerComponent } from 'components/common/CommonDatePicker';
import { UserContext } from 'context';
import { adjustBalanceApi } from '_services/accountsServices/ledgerStatementServices';
import { Callbacks } from 'jquery';

const   AdjustBalanceModal = (props) => {
    const { detailsData, venderType, calback } = props;
    const { masterData } = useContext(UserContext)

    const formObj = {
        company_id: StorageService.getCompanyId(),
        date: new Date().toISOString().split("T")[0],
        vendor_type: "",
        vendor_id: detailsData?._id || "",
        pay_type: 1,
        amount: ""
    }

    const [formValue, setFormValue] = useState(formObj);
    const [formError, setFormError] = useState({});
    const [isLoading, setIsLoading] = useState(false)

    // Update form when detailsData changes
    useEffect(() => {
        if (detailsData) {
            setFormValue(prev => ({
                ...prev,
                vendor_type: masterData?.vendor_type_list?.find((v) => v?.name == venderType).id || "",
                vendor_id: detailsData?._id || ""
            }));
        }
    }, [detailsData]);

    const handleOnChange = async (name, value) => {
        const decimalRegex = /^\d*\.?\d{0,2}$/;

        if (name === "amount" && !decimalRegex.test(value)) {
            return;
        }

        const stateObj = { ...formValue, [name]: value };
        setFormValue(stateObj);
    };

    // Calculate new balance dynamically
    const calculateNewBalance = () => {
        const currentBalance = detailsData?.balance || 0;
        const amount = parseFloat(formValue?.amount) || 0;

        // pay_type: 1 = To Pay (add), 2 = To Be Paid (subtract)
        if (formValue?.pay_type === 1) {
            return currentBalance + amount;
        } else if (formValue?.pay_type === 2) {
            return currentBalance - amount;
        }
        return currentBalance;
    };

    // Format currency
    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        }).format(amount || 0);
    };

    const newBalance = calculateNewBalance();
    const isButtonEnabled = formValue?.amount && parseFloat(formValue?.amount) > 0;

    const submitHandel = async () => {
        const payload = {
            company_id: formValue?.company_id,
            date: formValue?.date,
            vendor_type: Number(formValue?.vendor_type),
            vendor_id: formValue?.vendor_id,
            pay_type: formValue?.pay_type,
            amount: Number(formValue?.amount)
        }
        try {
            setIsLoading(true)
            const res = await adjustBalanceApi(payload)
            if (res?.responseCode === 200) {
                calback()
            }
        } catch (error) {

        }finally{
            setIsLoading(false)

        }
    }


    const propsAdjustLedger = {
        ...props,
        disabled: Number(formValue?.amount) === 0,
        isLoadding: isLoading,
        onSubmit: submitHandel
    };


    console.log("formValue", formValue, isButtonEnabled)

    return (
        <>
            <CommonModal {...propsAdjustLedger}>
                <div className='__adjBal_mx'>
                    <div className='__adjHead_fx'>
                        <div className='__adjleft'>
                            <h4>{masterData?.vendor_type_list?.find((v) => v?.name == venderType).name}</h4>
                        </div>
                        <div className='__adjRight'>
                            <h4>{detailsData?.name || 'N/A'}</h4>
                        </div>
                    </div>

                    <div className='__adjmid_part'>
                        <div className='__adS_main_fx'>
                            <div className='singleDiv'>
                                <DatePickerComponent
                                    label="Date"
                                    name="date"
                                    showTimeSelect={false}
                                    defaultTimeFix={false}
                                    startDate={formValue?.date}
                                    onChange={(data) => handleOnChange('date', data)}
                                    error={!!(typeof formError === "object") ? formError.date : ""}
                                />
                            </div>

                            <div className='checkBx_lv mt-0 p-0' style={{ width: '100%' }}>
                                {
                                    constant.MoneyRadio?.map((el, ind) => {
                                        return (
                                            <React.Fragment key={ind}>
                                                <div className='_dualCheckr_bx'>
                                                    <input
                                                        className="form-check-input"
                                                        id={+ind + "pay_type" + el?.value}
                                                        type="radio"
                                                        name="pay_type"
                                                        checked={Number(formValue?.pay_type) === Number(el?.value)}
                                                        value={formValue?.pay_type ? formValue?.pay_type : ""}
                                                        onChange={({ target: { name, value } }) =>
                                                            handleOnChange(name, el?.value)
                                                        }
                                                    />
                                                    <label htmlFor={+ind + "pay_type" + el.value} className="form-check-label" >
                                                        {el.label}
                                                    </label>
                                                </div>
                                            </React.Fragment>
                                        )
                                    })
                                }
                            </div>

                            <div className='singleDiv'>
                                <CommonInput
                                    type="text"
                                    placeholder="Enter Amount"
                                    label="Enter Amount"
                                    name='amount'
                                    value={formValue?.amount}
                                    onChange={(e) => handleOnChange('amount', e.target.value)}
                                    maxLength={10}
                                    error={formError.amount}
                                />
                            </div>
                        </div>
                    </div>

                    <div className='__adjHead_fx'>
                        <div className='__adjleft'>
                            <p>Current Balance</p>
                            <h4>{formatCurrency(detailsData?.balance)}</h4>
                        </div>
                        <div className='__adjRight'>
                            <p>New Balance</p>
                            <h4 style={{
                                color: newBalance < 0 ? '#dc3545' : '#28a745'
                            }}>
                                {formatCurrency(newBalance)}
                            </h4>
                        </div>
                    </div>
                </div>
            </CommonModal>
        </>
    )
}

export default AdjustBalanceModal